import { combineReducers } from 'redux';
// import { routerReducer } from 'react-router-redux';

import { connectRouter } from 'connected-react-router';
import tran from '../components/Translate/modules/tran'
import dialog from './modules/dialog';
import connector from './modules/connector';
import device from './modules/device';
import flush from './modules/flush';
import chains from './modules/chains';

const rootReducer = (browserHistory) => combineReducers({
  router: connectRouter(browserHistory),
  tran,
  connector,
  dialog,
  device,
  flush,
  chains
});
export default rootReducer;